import React from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@emotion/react'
import { light } from '@leroy-merlin-br/backyard-theme'
import { datadogRum } from '@datadog/browser-rum'

export default (ComponentToRender, selector, parent) => {
  const elementParent = parent || document
  const selectorElements = Array.from(elementParent.querySelectorAll(selector))

  if (!selectorElements.length) {
    return
  }

  selectorElements.forEach(el => {
    try {
      const { props: rawProps = '{}', ...dataset } = el.dataset
      const props = JSON.parse(rawProps)
      const root = createRoot(el)

      root.render(
        <ThemeProvider theme={light}>
          <ComponentToRender {...dataset} {...props} />
        </ThemeProvider>
      )
    } catch (e) {
      datadogRum.addError(e)
      throw e
    }
  })
}
